export function isValidArr (array){
    return Array.isArray(array) && array.length > 0;
}
export function isMobile (){
    return window.innerWidth < 600
}



// WEBPACK FOOTER //
// ./src/utils.js